import React from "react";

import AccountVerificationForm from "components/AccountVerification";

const AccountVerification = () => {
  return <AccountVerificationForm />;
};

export default AccountVerification;
